import { WlcmPlacesApi } from '@wlcm/angular/forms';
import { Observable, Subscriber } from 'rxjs';

export interface NormalizedAddress {
  fullAddress: string;
  street: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  latitude: number | undefined;
  longitude: number | undefined;
  placeId: string;
}

export const normalizePlaceResult = (result: google.maps.places.PlaceResult): NormalizedAddress => {
  const components = result.address_components || [];

  const getComponent = (type: string, valueType: 'long_name' | 'short_name' = 'long_name'): string =>
    components.find((c) => c.types.includes(type))?.[valueType] || '';

  const streetNumber = getComponent('street_number');
  const route = getComponent('route');
  const city =
    getComponent('locality') ||
    getComponent('postal_town') ||
    getComponent('sublocality') ||
    getComponent('administrative_area_level_2');
  const state = getComponent('administrative_area_level_1', 'short_name');
  const zipcode = getComponent('postal_code');
  const country = getComponent('country');

  const location = result.geometry?.location;
  const latitude = location ? location.lat() : undefined;
  const longitude = location ? location.lng() : undefined;

  return {
    fullAddress: result.formatted_address || '',
    street: [streetNumber, route].filter(Boolean).join(' ').trim(),
    city,
    state,
    zipcode,
    country,
    latitude,
    longitude,
    placeId: result.place_id || '',
  };
};

export const getPlaceDetails = (
  placesApi: WlcmPlacesApi,
  placeId: string
): Observable<google.maps.places.PlaceResult | null> => {
  return new Observable((subscriber: Subscriber<google.maps.places.PlaceResult | null>) => {
    placesApi.placesService.getDetails({ placeId }, (result: google.maps.places.PlaceResult | null) => {
      subscriber.next(result);

      subscriber.complete();
    });
  });
};
